module.exports = __webpack_public_path__ + "static/media/track-tree-fear-of-a-blank-planet.3d89839b.png";